import { animateScroll } from 'react-scroll'
import styled from 'styled-components'
import { Icon } from 'src/assets/svg/Icon'
import { useEffect, useState } from 'react'
import { ZIndex } from 'src/styles/mixin'
import { fadeTransitionProps } from 'src/styles/animation'
import useRouteToMetaData from 'src/hooks/useRouteToMetaData.hook'
import useDynamicWidth from 'src/hooks/useDynamicWidth.hook'

export interface TopButtonProps {
  isPosition?: string
}

const TopButton = ({ isPosition }: TopButtonProps) => {
  const { isTopButton } = useRouteToMetaData()
  const [showTopButton, setShowTopButton] = useState(false)
  const scrollToTopHandler = () => animateScroll.scrollToTop()
  const headerTabHeightSize = 50
  const { deviceWidth } = useDynamicWidth()

  const bottomPosition = deviceWidth > 688 ? '30px' : !!isPosition ? isPosition : isTopButton
  const rightPosition = deviceWidth > 688 ? `${(deviceWidth - 688) / 2 - 62}px` : '10px'

  useEffect(() => {
    const handleScroll = () => {
      setShowTopButton(window.scrollY > headerTabHeightSize)
    }

    // window에 scroll 이벤트를 넣는다.
    window.addEventListener('scroll', handleScroll)

    // 페이지를 벗어날 때 이벤트를 제거한다.
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (!showTopButton || !bottomPosition) {
    return null
  }

  return (
    <TopButtonWrap
      onClick={scrollToTopHandler}
      $bottomPosition={bottomPosition as string}
      $rightPosition={rightPosition as string}
      {...fadeTransitionProps}
    >
      <Icon.TopButtonArrow />
    </TopButtonWrap>
  )
}
export default TopButton

const TopButtonWrap = styled.div<{ $bottomPosition: string; $rightPosition: string }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: fixed;
  align-items: center;
  width: 46px;
  height: 46px;
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid var(--black-6);
  background: var(--white);
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.1);
  bottom: ${(props) => props.$bottomPosition};
  right: ${(props) => props.$rightPosition};
  z-index: ${ZIndex.TopButton};
`
